import { render, staticRenderFns } from "./DdaCategoryList.vue?vue&type=template&id=fa72f164&scoped=true"
import script from "./DdaCategoryList.vue?vue&type=script&lang=js"
export * from "./DdaCategoryList.vue?vue&type=script&lang=js"
import style0 from "./DdaCategoryList.vue?vue&type=style&index=0&id=fa72f164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa72f164",
  null
  
)

export default component.exports